import { render, staticRenderFns } from "./ViewOrganisations.vue?vue&type=template&id=684d366c&scoped=true"
import script from "./ViewOrganisations.vue?vue&type=script&lang=js"
export * from "./ViewOrganisations.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganisations.vue?vue&type=style&index=0&id=684d366c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d366c",
  null
  
)

export default component.exports